import { capitalize } from 'vue';

import formatNumber from '@/utils/NumberFormatter';

export default {
  after: (field, [target]) => `Dieses ${capitalize(field)} muss nach ${target}.`,
  after_or_equal: (field, [target]) => `Das ${capitalize(field)} muss nach oder gleich ${target} sein.`,
  alpha_dash: (field) =>
    `Dieses ${capitalize(field)} kann alpha-numerische Zeichen sowie Gedanken- und Unterstriche enthalten `,
  alpha_num: (field) => `Dieses ${capitalize(field)} darf nur alpha-numerische Zeichen enthalten`,
  alpha_spaces: (field) => `Dieses ${capitalize(field)} darf nur alphabetische Zeichen sowie Leerzeichen enthalten`,
  alpha: (field) => `Dieses ${capitalize(field)} darf nur alphabetische Zeichen enthalten.`,
  before: (field, [target]) => `Dieses ${capitalize(field)} muss vor ${target}.`,
  before_or_equal: (field, [target]) => `Das ${capitalize(field)} muss vor oder gleich ${target} sein.`,
  between: (field, [min, max]) => `Dieses ${capitalize(field)} muss zwischen ${min} und ${max}.`,
  boolean: (field) => `The value ${capitalize(field)} is not a valid boolean value`, // TO TRANSLATE
  confirmed: (field) => `Dieser ${capitalize(field)} Nachweis passt nicht zusammen.`,
  credit_card: (field) => `Dieses ${capitalize(field)} ist ungültig`,
  date_between: (field, [min, max]) => `Dieses ${capitalize(field)} muss zwischen ${min} und ${max}.`,
  date_format: (field, [format]) => `Dieses ${capitalize(field)} muss in folgendes Format ${format}.`,
  date_time: (field) => `The ${capitalize(field)} field is not a valid date.`,
  decimal: (field, [decimals] = ['*']) =>
    `Dieses ${capitalize(field)} muss numerisch sein und kann ${decimals === '*' ? '' : decimals} Dezimalstellen enthalten.`,
  digits: (field, [length]) => `Dieses ${capitalize(field)} muss numerisch sein und genau ${length} digits enthalten`,
  dimensions: (field, [width, height]) =>
    `Dieses ${capitalize(field)} muss ${width} sein und Pixel von ${height} pixels enthalten.`,
  domain: (field) =>
    `${capitalize(field)} is not a valid domain, here are some examples: apple.com, coca-cola.com, google.com`, //  TO TRANSLATE
  email: (field) => `Dieses ${capitalize(field)} muss eine gültige E-Mail Adresse enthalten.`,
  ext: (field) => `Dieses ${capitalize(field)} muss eine gültige Datei enthalten.`,
  greater_than: (field, min) => `The ${capitalize(field)} muss größer als ${formatNumber(min, '0,0')} sein.`,
  image: (field) => `Dieses ${capitalize(field)} muss ein Bild sein.`,
  in: (field) => `Dieses ${capitalize(field)} muss einen gültigen Wert haben`,
  ip: (field) => `Dieses ${capitalize(field)} muss eine gültige IP Adresse enthalten.`,
  less_than: (field, max) => `Dieses ${capitalize(field)} muss unter ${formatNumber(max, '0,0')} liegen.`,
  max: (field, [length]) => `Dieses ${capitalize(field)} darf nicht mehr als ${length} Zeichen enthalten.`,
  max_value: (field, max) => `Dieses ${capitalize(field)} muss mindestens ${formatNumber(max, '0,0')} enthalten.`,
  mimes: (field) => `Dieses ${capitalize(field)} muss ein gültiger Dateien Typ sein.`,
  min: (field, [length]) => `Dieses ${capitalize(field)} muss mindestens ${length} Zeichen enthalten.`,
  min_value: (field, min) => `Dieses ${capitalize(field)} muss mindestens ${formatNumber(min, '0,0')} groß sein.`,
  not_empty: (field) => `${capitalize(field)} must not be empty.`, // TO TRANSLATE
  not_empty_or_whitespace: (field) => `${capitalize(field)} must not be empty.`, // TO TRANSLATE
  not_in: (field) => `Dieses ${capitalize(field)} muss einen gültigen Wert enthalten`,
  not_in_use: (field) => `The ${capitalize(field)} is already in use.`, // TO TRANSLATE
  numeric: (field) => `Dieses ${capitalize(field)} darf nur numerische Zeichen enthalten.`,
  regex: (field) => `${capitalize(field)} Format ist ungültig`,
  required: (field) => `${capitalize(field)} Pflichtfeld`,
  size: (field, [size]) => `Dieses ${capitalize(field)} muss kleiner als ${size} KB sein.`,
  url: (field) => `Dieses ${capitalize(field)} enthält keine gültige URL`,
  url_with_macros: (field) => `Dieses ${capitalize(field)} enthält keine gültige URL`,
  uuid: (field) => `${field} is not a valid UUID`, // TO TRANSLATE
  string_equals: () => 'Values are not equal', // TO TRANSLATE
  password: () => 'Password is too weak', // TO TRANSLATE
};
